import {Col, Row} from "react-bootstrap";
import React from "react";
import {
  MM_QUESTION
} from "../../scripts/myga-model";
import {validateCondition} from "../../scripts/validation";
import SubQuestions from "./SubQuestions";
import {PROCESS_QUESTION_TEXT, PROCESS_TEXT_JUSTIFICATION} from "../../scripts/layout-manager";

function QuestionRadio(props) {
  
  const {data, question, handleChange, required, responseClass} = props;

  const responses = question.response[MM_QUESTION.response.constraints];
  // const buttonCount = responses.length;
  // const vOrientation = question[MM_QUESTION.visualOrientation];
  // const qCols = (vOrientation===QUESTION_VISUAL_ORIENTATION.horizontal) ? (buttonCount<3) ? 7 : 6 : 12;
  // const aCols = (qCols<12) ? 12 - qCols : 12;
  // const rCols = (buttonCount<3) ? 6 : 4;
  const questions = question.questions || [];

  let widthOverride = {}
  if (question.response.justification === 'center') {
    widthOverride = {width: '100%'}
  }

  let textAlignment = PROCESS_TEXT_JUSTIFICATION(question.response.labelJustification);

  return (
      <Row className={`pl-0 pr-0 align-self-center ${textAlignment} ${responseClass}`} style={widthOverride}>
        {
          responses.map((response,index)=>{
            const disabled = !validateCondition(question.enableCondition,data) || !validateCondition(response.enableCondition,data);
            return (
              <Col key={index} className={'pl-0'}>
                <div className='form-check form-check-inline'>
                  <input type="radio"
                         className="form-check-input"
                         required={required}
                         id={response.key+response.value}
                         name={response.key}
                         value={response.value}
                         checked={data[response.key] === response.value}
                         disabled={disabled}
                         onClick={handleChange(response.key)}
                         onChange={() => {}}/>
                  <label className="form-check-label" htmlFor={response.key+response.value}>{PROCESS_QUESTION_TEXT(response)}</label>
                </div>
                <SubQuestions questions={questions}
                              anchorTo={response.key}
                              handleChange={handleChange}
                              data={data}
                />
              </Col>
            )
          })
        }
      </Row>
  );
  
}

export default QuestionRadio;